import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import {LadingCodeState} from "@/interfaces/state";
import {IdMapper} from "@/interfaces/state/base";
import {LadingCode} from "@/interfaces/entity";
import {PaginationMeta} from "@/interfaces/common";
import {LadingCodeParams} from "@/modules/ladingcodes/params";
import store from "@/store";
import { union } from 'lodash';
import {allLadingCodes, createLadingCode, listLadingCodes} from "@/modules/ladingcodes/services";

@Module({ dynamic: true, name: "ladingcode", store })
class LadingCodeModule extends VuexModule implements LadingCodeState {
    data: IdMapper<LadingCode> = {};
    ids: number[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: LadingCodeParams = new LadingCodeParams();

    dataAll: IdMapper<LadingCode> = {};
    idsAll: number[] = [];

    @Mutation
    private MAP_LADING_CODE(payload: any) {
        const idMapper: IdMapper<LadingCode> = {};
        this.meta = payload.meta;
        this.ids = payload.datas.map((ladingCode: LadingCode) => {
            idMapper[ladingCode.id] = ladingCode;
            return ladingCode.id;
        });
        this.data = idMapper;
    }

    @Mutation
    private ADD_LADING_CODE(payload: LadingCode) {
        this.ids = union(this.ids, [payload.id]);
        this.data[payload.id] = payload;
    }

    @Mutation
    private ADD_LADING_CODES(payload: Array<LadingCode>) {
        payload.forEach((ladingCode: LadingCode) => {
            this.ids = union(this.ids, [ladingCode.id]);
            this.data[ladingCode.id] = ladingCode;
        });
    }

    @Mutation
    private UPDATE_LADING_CODE_PARAMS(payload: any) {
        this.params = payload;
    }

    @Mutation
    private MAP_ALL_LADING_CODE(payload: any) {
        const idMapper: IdMapper<LadingCode> = {};
        this.idsAll = payload.datas.map((ladingCode: LadingCode) => {
            idMapper[ladingCode.id] = ladingCode;
            return ladingCode.id;
        });
        this.dataAll = idMapper;
    }

    @Action({ rawError: true })
    public async createLadingCode(payload: any) {
        const { data } = await createLadingCode(payload);
        this.ADD_LADING_CODES(data.datas);
        return data.datas;
    }

    @Action({ rawError: true })
    public async listLadingCodes(payload: any) {
        const { data } = await listLadingCodes(payload);
        this.MAP_LADING_CODE(data);
    }

    @Action({ rawError: true })
    public async allLadingCodes(payload: any) {
        const { data } = await allLadingCodes(payload);
        return data.datas;
    }

    @Action({ rawError: true })
    public async updateLadingCodeParams(payload) {
        this.UPDATE_LADING_CODE_PARAMS(payload);
    }
}

export const LadingCodeStore = getModule(LadingCodeModule);
